export enum Routes {
  BillingAccounts = 'billing/accounts',
  PaymentForm = 'public/billing/payment_form',
  PaymentProviderError = 'payment_provider_error',
}
